const expand = {
  user: { select: 'id,fullName' },
  userGroup: { select: 'id,name' },
};

/**
 * OData select/expand for global user-group approvers (by user).
 * Used by createCrudModel via CoreQueries.GlobalUserGroupApproverUser.
 */
export default {
  paged: {
    select: 'id,approvalLevel',
    notSelectSearch: 'approvalLevel',
    expand,
  },
  item: {
    select: 'id,approvalLevel',
    expand,
  },
  itemDetail: {
    select: 'id,approvalLevel,updated,created,creator',
    expand: {
      ...expand,
      userCreator: { select: 'fullName' },
      userModifier: { select: 'fullName' },
    },
  },
};
